import { render, staticRenderFns } from "./blog-follow.vue?vue&type=template&id=a4f37728&"
import script from "./blog-follow.vue?vue&type=script&lang=js&"
export * from "./blog-follow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports